export default __webpack_public_path__ + "static/media/light-sound.9b97e7a6.png";